const verses = [
  {
    id: 1,
    quote: "John 14:6 (New International Version)",
    content:
      "Jesus answered, “I am the way and the truth and the life. No one comes to the Father except through me.",
    background: "./img/1.jpeg",
  },
  {
    id: 2,
    quote: "John 3:16 (New International Version)",
    content:
      "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.",
    background: "./img/2.jpeg",
  },
  {
    id: 3,
    quote: "1 Timothy 2:5 (New International Version)",
    content:
      "For there is one God and one mediator between God and mankind, the man Christ Jesus",
    background: "./img/3.jpeg",
  },
  {
    id: 4,
    quote: "Acts 4:12 (New International Version)",
    content:
      "Salvation is found in no one else, for there is no other name under heaven given to mankind by which we must be saved.",
    background: "./img/4.jpeg",
  },
  {
    id: 5,
    quote: "Romans 10:8-10 (New International Version)",
    content:
      "But what does it say? “The word is near you; it is in your mouth and in your heart,” that is, the message concerning faith that we proclaim: If you declare with your mouth, “Jesus is Lord,” and believe in your heart that God raised him from the dead, you will be saved.  For it is with your heart that you believe and are justified, and it is with your mouth that you profess your faith and are saved.",
    background: "./img/5.jpeg",
  },
  {
    id: 6,
    quote: "Matthew 7:12 (New International Version)",
    content:
      "So in everything, do to others what you would have them do to you, for this sums up the Law and the Prophets.",
    background: "./img/6.jpeg",
  },
  {
    id: 7,
    quote: "Matthew 22:36-40 (New International Version)",
    content:
      "“Teacher, which is the greatest commandment in the Law?” Jesus replied: “‘Love the Lord your God with all your heart and with all your soul and with all your mind.’ This is the first and greatest commandment. And the second is like it: ‘Love your neighbor as yourself.’ All the Law and the Prophets hang on these two commandments.”",
    background: "./img/7.jpeg",
  },
  {
    id: 8,
    quote: "Hebrews 11:1 (New International Version)",
    content:
      "Now faith is confidence in what we hope for and assurance about what we do not see. ",
    background: "./img/8.jpeg",
  },
  {
    id: 9,
    quote: "Isaiah 9:6-7 (New International Version)",
    content:
      "For to us a child is born, to us a son is given, and the government will be on his shoulders. And he will be called Wonderful Counselor, Mighty God, Everlasting Father, Prince of Peace. Of the greatness of his government and peace there will be no end. He will reign on David’s throne and over his kingdom, establishing and upholding it with justice and righteousness from that time on and forever. The zeal of the Lord Almighty will accomplish this.",
    background: "./img/9.jpeg",
  },
  {
    id: 10,
    quote: "Matthew 28:18-20 (New International Version)",
    content:
      "Then Jesus came to them and said, “All authority in heaven and on earth has been given to me. Therefore go and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything I have commanded you. And surely I am with you always, to the very end of the age.”",
    background: "./img/10.jpeg",
  },
];

export default verses;
